import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../common/BaseComponent';
import { User } from 'src/app/model/user';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})

export class ErrorComponent extends BaseComponent implements OnInit {
  messageKey: string;

  constructor(injector: Injector,) {
    super(injector);
  }

  ngOnInit(): void {
    this.messageKey = "bss.error.message";

    const sessionUser = sessionStorage.getItem("user");
    console.log("Error page get session user: " + sessionUser);

    if (sessionUser) {
      let user: User = JSON.parse(sessionUser);
      if (user.accountStatus && user.accountStatus.startsWith("bss.api.error")) {
        this.messageKey = user.accountStatus;
      }
    }  
  }
}
